var map = {
	"./BookOpen.svg": 54,
	"./CityVision.png": 55,
	"./CreditCardDel.png": 57,
	"./FB.svg": 59,
	"./GradHat.png": 24,
	"./GradHatG.png": 62,
	"./HomomorphicEncryption.png": 63,
	"./Logo.png": 66,
	"./RDMVS.png": 68,
	"./handwritingDetection.png": 73,
	"./twitter.svg": 74,
	"./universal_photo.jpeg": 75,
	"./universal_photo_1.jpeg": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100;